module.exports = [
	{
		"id": 2430,
		"customerName": "Lakshmi Kalla",
		"email": "lakshmiKalla43@gmil.com",
		"phone": "9866724700",
		"totalOrders": 886,
		"totalSpend": 58765
	},
	{
		"id": 600,
		"customerName": "Krishnaveni Kurakula",
		"email": "Krishnaveni.choutkur@gmail.com",
		"phone": "7893498069",
		"totalOrders": 708,
		"totalSpend": 57643.5
	},
	{
		"id": 396,
		"customerName": "Varsah Reddy",
		"email": "varshareddypulagam@gmail.com",
		"phone": "8688929999",
		"totalOrders": 815,
		"totalSpend": 53520
	},
	{
		"id": 976,
		"customerName": "Gopal  Reddy ",
		"email": "veeragopalreddy@gmail.com",
		"phone": "8970356666",
		"totalOrders": 514,
		"totalSpend": 48233
	},
	{
		"id": 481,
		"customerName": "Vadisela revathi Revathi",
		"email": "blossomdesigners.revathi@gmail.com",
		"phone": "7989816377",
		"totalOrders": 549,
		"totalSpend": 46500
	},
	{
		"id": 244,
		"customerName": "Mounika K",
		"email": "nainikaembroidary@gmail.com",
		"phone": "7993971072",
		"totalOrders": 438,
		"totalSpend": 45991
	},
	{
		"id": 188,
		"customerName": "Raju.  M",
		"email": "mnagaraju12172@gmail.com",
		"phone": "8074662940",
		"totalOrders": 641,
		"totalSpend": 45246
	},
	{
		"id": 128,
		"customerName": "Geetha Reddy",
		"email": "ggeetha.reddy29@gmail.com",
		"phone": "8886333547",
		"totalOrders": 673,
		"totalSpend": 45181
	},
	{
		"id": 5545,
		"customerName": "sri matchings",
		"email": "srimatchings136@gmail.com",
		"phone": "8309374094",
		"totalOrders": 608,
		"totalSpend": 43840
	},
	{
		"id": 3868,
		"customerName": "Kotha Lova subrahmanyam",
		"email": "bangaram.lova@gmail.com",
		"phone": "9866426072",
		"totalOrders": 486,
		"totalSpend": 43615
	},
	{
		"id": 1239,
		"customerName": "Anil sai Undamattla",
		"email": "undamatlasireesha06@gmail.com",
		"phone": "9966275858",
		"totalOrders": 561,
		"totalSpend": 42355
	},
	{
		"id": 2940,
		"customerName": "Kalavathi Sreeram",
		"email": "sreeramkala@gmail.com",
		"phone": "9490539215",
		"totalOrders": 561,
		"totalSpend": 42124.1
	},
	{
		"id": 26,
		"customerName": "Sushmitha Gottipati",
		"email": "gottipatisusmitha2018@gmail.com",
		"phone": "9490777154",
		"totalOrders": 552,
		"totalSpend": 42077
	},
	{
		"id": 502,
		"customerName": "Suma Latha",
		"email": "sumasareekuchu@gmail.com",
		"phone": "6363341844",
		"totalOrders": 605,
		"totalSpend": 40365
	},
	{
		"id": 1951,
		"customerName": "Sandhya Miriyala",
		"email": "sandhyamiriyala33@gmail.com",
		"phone": "9160131830",
		"totalOrders": 436,
		"totalSpend": 40145
	},
	{
		"id": 2737,
		"customerName": "Uma Bashetti",
		"email": "umabashetti@gmail.com",
		"phone": "8106861609",
		"totalOrders": 535,
		"totalSpend": 39780
	},
	{
		"id": 1076,
		"customerName": "Satya Nallamilli",
		"email": "satyasri0311@gmail.com",
		"phone": "9515605734",
		"totalOrders": 461,
		"totalSpend": 39486
	},
	{
		"id": 41,
		"customerName": "Swapna Sajjala",
		"email": "swapnasajjala@gmail.com",
		"phone": "7386361906",
		"totalOrders": 456,
		"totalSpend": 39168
	},
	{
		"id": 286,
		"customerName": "Vijayalakshmi Vijayalakshmi computer work",
		"email": "gollaramu06@gmail.com",
		"phone": "7032984130",
		"totalOrders": 408,
		"totalSpend": 39026
	},
	{
		"id": 3229,
		"customerName": "Sanjay  Kumar",
		"email": "konasnj@gmail.com",
		"phone": "9550579714",
		"totalOrders": 314,
		"totalSpend": 37993.6
	},
	{
		"id": 10522,
		"customerName": "Bharathi  Botique",
		"email": "bharathikotu@gmail.com",
		"phone": "8317560405",
		"totalOrders": 238,
		"totalSpend": 37657
	},
	{
		"id": 3,
		"customerName": "Ambika Gunaganti",
		"email": "ambikaladiesfashions@gmail.com",
		"phone": "8639050202",
		"totalOrders": 379,
		"totalSpend": 35790
	},
	{
		"id": 870,
		"customerName": "Varalaxmi Chintapalli",
		"email": "varalakshmi.chintapalli111@gmail.com",
		"phone": "6300014877",
		"totalOrders": 444,
		"totalSpend": 35250
	},
	{
		"id": 4374,
		"customerName": "Kalyani Kammara",
		"email": "abhiakhi029@gmail.com",
		"phone": "9989062512",
		"totalOrders": 500,
		"totalSpend": 34110
	},
	{
		"id": 3939,
		"customerName": "Thalapaka Sumalatha",
		"email": "sumalathathalapaka@gmail.com",
		"phone": "9392641415",
		"totalOrders": 458,
		"totalSpend": 33937
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/components/admin/view/report/view/top25Customers.json
// module id = 6520
// module chunks = 0